import {useState} from "react";

/**
 * @deprecated
 */
export default function useDownloadState() {
    let [downloading, setDownloadingState] = useState(false);
    let [result, setResult] = useState(null);
    let [error, setError] = useState(null);

    let setDownloading = (value) => {
        setDownloadingState(value);

        if(value === true) {
            setResult(null);
            setError(null);
        }
    };

    return [
        {
            downloading: downloading,
            result: result,
            error: error,
        },
        setDownloading,
        setResult,
        setError
    ];
}
